export interface Notification {
  id: string
  type: "success" | "warning" | "info" | "system"
  title: string
  message: string
  time: string
  read: boolean
  action?: {
    label: string
    onClick: () => void
  }
}

export const defaultNotifications: Notification[] = [
  {
    id: "1",
    type: "success",
    title: "Career Path Completed",
    message: "You've successfully completed the Chef career path assessment",
    time: "5 min ago",
    read: false,
    action: {
      label: "View Results",
      onClick: () => console.log("View results clicked"),
    },
  },
  {
    id: "2",
    type: "warning",
    title: "Upcoming Assessment",
    message: "Your Space Explorer Quiz is scheduled for tomorrow",
    time: "1 hour ago",
    read: false,
    action: {
      label: "Prepare",
      onClick: () => console.log("Prepare clicked"),
    },
  },
  {
    id: "3",
    type: "info",
    title: "New Learning Resource",
    message: "New study materials available for Mathematics",
    time: "2 hours ago",
    read: true,
    action: {
      label: "Explore",
      onClick: () => console.log("Explore clicked"),
    },
  },
  {
    id: "4",
    type: "system",
    title: "System Update",
    message: "New features available in your dashboard",
    time: "1 day ago",
    read: true,
  },
  {
    id: "5",
    type: "success",
    title: "Quiz Submitted",
    message: "Your Python Basics quiz has been graded. You scored 92%!",
    time: "2 days ago",
    read: true,
  },
  {
    id: "6",
    type: "info",
    title: "Course Recommendation",
    message: "Based on your interests, we recommend Web Development 101",
    time: "3 days ago",
    read: true,
  },
]
